
export function computeCosts(images = [], videos = [], pricing = {}, isFeatured, featuredPaid, includedImages, includedVideos) {
	const enabledImages = images.filter(i => i.enabled);
	const enabledVideos = videos.filter(v => v.enabled);
	const vatPercentage = pricing.vat_percent || 23;
	const vatDivisor = 1 + (pricing.vat_percent / 100);
	const pricingExtraImageNoVat = (pricing.price_extra_image / vatDivisor).toFixed(2)
	const pricingExtraVideoNoVat = (pricing.price_extra_video / vatDivisor).toFixed(2)
	const freeImgLimit = includedImages || pricing.free_images_limit || 5;
	const freeVidLimit = includedVideos || pricing.free_videos_limit || 1;
	const extraImages = Math.max(0, enabledImages.length - freeImgLimit);
	const extraVideos = Math.max(0, enabledVideos.length - freeVidLimit);
	const imgCost = extraImages * (pricing.price_extra_image || 0);
	const imgCostNoVat = imgCost > 0 ? (imgCost / vatDivisor).toFixed(2) : 0;
	const vidCost = extraVideos * (pricing.price_extra_video || 0);
	const vidCostNoVat = vidCost > 0 ? (vidCost / vatDivisor).toFixed(2) : 0;
	const featCost = isFeatured ? featuredPaid ? 0 : (pricing.price_featured_ad || 0) : 0;
	const featCostNoVat = featCost > 0 ? (featCost / vatDivisor).toFixed(2) : 0;
	const total = imgCost + vidCost + featCost;
	const subTotal = (total / vatDivisor).toFixed(2);
	const vatAmount = (total - subTotal).toFixed(2);

	return {
		enabledImages,
		enabledVideos,
		vatPercentage,
		vatDivisor,
		pricingExtraImageNoVat,
		pricingExtraVideoNoVat,
		freeImgLimit,
		freeVidLimit,
		extraImages,
		extraVideos,
		imgCost,
		imgCostNoVat,
		vidCost,
		vidCostNoVat,
		featCost,
		featCostNoVat,
		total,
		subTotal,
		vatAmount
	}
}

export function defaultPricing() {
	return {
		free_images_limit: 5, price_extra_image: 0.70,
		free_videos_limit: 1, price_extra_video: 3.00,
		max_video_size_mb: 50, price_featured_ad: 10.00,
		vat_percent: 23
	}
}